module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flyout-data flyout-data__center grid grid__all-around grid__flyout-data",
    class: [_vm.bemFacet]
  }, [_c('div', {
    staticClass: "grid--row flyout-data--row flyout-data--row__dot-separator-outer"
  }, [_c('div', {
    staticClass: "flyout-data--col grid--col"
  }, [_c('a', {
    staticClass: "u-reset flyout-data--teaser flyout-teaser",
    attrs: {
      "href": _vm.teaser.link.content.href
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onTeaserClick()
      }
    }
  }, [_c('span', {
    staticClass: "flyout-teaser--quote"
  }, [_c('span', {
    staticClass: "flyout-teaser--quote-text",
    domProps: {
      "textContent": _vm._s(_vm.teaser.quote)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "flyout-teaser--btn btn btn__outline btn__small",
    attrs: {
      "data-inert": ""
    }
  }, [_c('span', {
    staticClass: "btn--wrap"
  }, [_c('span', {
    staticClass: "btn--text",
    domProps: {
      "innerHTML": _vm._s(_vm.teaser.link.content.label)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btn--icon"
  }, [_c('cmp-icon', {
    attrs: {
      "symbol": "chevron_right",
      "size": "x-small"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "flyout-data--col grid--col"
  }, [(_vm.links.length) ? _c('div', {
    staticClass: "grid--row flyout-data--row flyout-data--row__dot-separator-inner"
  }, _vm._l((_vm.links), function(link, idx) {
    return _c('div', {
      staticClass: "flyout-data--col flyout-data--col__vertical grid--col"
    }, [_c('cmp-rich-button', {
      staticClass: "flyout-data--rich-button",
      attrs: {
        "button-facet": "main-nav",
        "plugin": link
      }
    })], 1)
  })) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-28027fbd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28027fbd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/flyout-data/index.vue
// module id = 519
// module chunks = 7